<template>
  <router-view />
</template>

<script>
import { defineComponent } from 'vue'
import 'bootstrap';

import './css/style.css';
import 'bootstrap/dist/css/bootstrap.min.css';

export default defineComponent({
})
</script>
